import React from "react";
import classnames from "classnames";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

import usexAPI from "store/customHooks/usexAPI";
import { getUrlPathnameAndSearch } from "utils/url";

import FlWrapper from "components/gnb/content/util/FlWrapper";
import CloseButton from "components/gnb/content/util/CloseButton";
import { xAPI_ID_VALUE } from "utils/xAPI_PATH";
import { setXAPIPath } from "utils/localStorage";

function SecondDepthMenu(props) {
    const { itemList, changeSecondDepthMenu, currentMenuInfo, isSecondDepthSubMenuOpen, toggleSecondDepthSubMenu } =
        props;
    const { ServiceUnit_A } = usexAPI();

    const handleClick = (info) => {
        ServiceUnit_A(xAPI_ID_VALUE.serviceUnit.btn_menu_0002, getUrlPathnameAndSearch(info.MENU_URL));
        changeSecondDepthMenu(info);
        setXAPIPath("G");
    };

    const handleClickCloseButton = () => {
        toggleSecondDepthSubMenu();
    };

    return (
        <FlWrapper>
            <ButtonDropdown
                className="selectCustom3"
                isOpen={isSecondDepthSubMenuOpen}
                toggle={toggleSecondDepthSubMenu}
            >
                <DropdownToggle className="optionfirst" caret>
                    {currentMenuInfo.MENU_NAME}
                </DropdownToggle>
                <DropdownMenu className="optionlist">
                    {itemList.map((info, idx) => (
                        <DropdownItem
                            className={classnames({ oncolor: info.MENU_CD === currentMenuInfo.MENU_CD })}
                            key={idx}
                            onClick={() => handleClick(info)}
                        >
                            {info.MENU_NAME}
                        </DropdownItem>
                    ))}
                    <CloseButton handleClick={handleClickCloseButton} />
                </DropdownMenu>
            </ButtonDropdown>
        </FlWrapper>
    );
}

export default SecondDepthMenu;
